import React from 'react';
import CalendarDatesIcon from '@ps-design-system/icons/CalendarDates/CalendarDates32';
import CheckCircleIcon from '@ps-design-system/icons/CheckCircle/CheckCircle32';
import LockIcon from '@ps-design-system/icons/Lock/Lock32';
import { Text } from '@ps-design-system/components/Text';
import ValuePropsStrings from './strings';

const ValueProps = () => {
  return (
    <div className="ValueProps">
      <div className="ValueProps_item">
        <div className="ValueProps_icon">
          <CalendarDatesIcon/>
        </div>
        <Text typeface="body-2">{ValuePropsStrings.linkCalendar}</Text>
      </div>

      <div className="ValueProps_divider"/>

      <div className="ValueProps_item">
        <div className="ValueProps_icon">
          <CheckCircleIcon/>
        </div>
        <Text typeface="body-2">{ValuePropsStrings.connectAccount}</Text>
      </div>

      <div className="ValueProps_divider"/>

      <div className="ValueProps_item">
        <div className="ValueProps_icon">
          <LockIcon/>
        </div>
        <Text typeface="body-2">{ValuePropsStrings.privacyNotice}</Text>
      </div>
    </div>
  );
};

export default ValueProps;
